import FormInput from "../FormInput/FormInput";
import styles from './CodeInput.module.scss';
import {useTranslation} from "react-i18next";

interface IProps {
  value: { [key: string]: string };
  setValue: (e: any, pasteFlag?: boolean) => void;
}

const CodeInput = ({ value, setValue }: IProps) => {
  const { i18n } = useTranslation();
  const dirData = i18n.language === 'ar' ? 'rtl' : 'ltr';

  const handleInputChange = (id: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = e.target.value.replace(/[^0-9]/g, ''); // Оставляем только цифры
    setValue({ target: { id: id.toString(), value: sanitizedValue } });

    if (sanitizedValue.length === 1) {
      const nextInput = document.getElementById((id + 1).toString()) as HTMLInputElement;
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (id: number) => (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && !value[id.toString()]) {
      const prevInput = document.getElementById((id - 1).toString()) as HTMLInputElement;
      if (prevInput) prevInput.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    setValue(e, true);
  };

  return (
    <div className={styles.inputWrapper}>
      {[1, 2, 3, 4].map((id) => (
        <FormInput
          key={id}
          dirData={dirData}
          className={styles.codeInput}
          setValue={handleInputChange(id)}
          value={value[id.toString()] || ''}
          placeHolder=""
          name="code"
          type="text"
          maxLength={1}
          id={id.toString()}
          onPaste={handlePaste}
          inputMode="numeric"
          pattern="[0-9]*"
          onKeyDown={handleKeyDown(id)}
        />
      ))}
    </div>
  );
};

export default CodeInput;
